import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEdit(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit',
    alias: 'factoryEdit',
    loader: i18nLoader,
  });
}
